import { render, staticRenderFns } from "./VariationGraph.vue?vue&type=template&id=1f309e51&"
import script from "./VariationGraph.vue?vue&type=script&lang=ts&"
export * from "./VariationGraph.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports